import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import { router } from "./App";
import { AuthProvider } from "./lib/auth";
import { syncManifestLink } from "./lib/pwaManifestLink";
import { installPhonePreviewFrame } from "./lib/phonePreviewFrame";
import "./index.css";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

// Register the service worker (no-op in dev where the SW is disabled). Step 1:
// installable app shell. The offline job loop bolts on later.
registerSW({ immediate: true });

// Point <link rel="manifest"> at the engineer-scoped manifest on /engineer surfaces and the office
// manifest elsewhere (Session AFG). The initial call covers a full page load at the install target
// (the QR opens /engineer directly), so an engineer installing from that page gets the "ELE Engineer"
// app locked to /engineer/. The subscription keeps it correct across client-side navigations (e.g. a
// bare "/" load redirecting to /engineer before the engineer taps Install).
syncManifestLink(window.location.pathname);
router.subscribe((state) => syncManifestLink(state.location.pathname));

// The Phone view (Session BDZ): when this page is the stage's iframe, tell the stage where the app is and take its
// text size and navigation. A no-op in every other window.
installPhonePreviewFrame(router);

createRoot(rootEl).render(
  <StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </StrictMode>,
);
